import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Header, Segment, List, Form, Input, Button, Modal, Table, Icon, Dropdown, Grid } from 'semantic-ui-react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { setActivePage, getPaymentTerms, addPaymentTerms, removePaymentTerms } from '../actions';

// helper function to reorder item
const reorderList = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class PaymentTerms extends Component {
    constructor(props) {
        props.getPaymentTerms({});
        super(props);
        this.state = {
            openModal: false,
            materials: null,
            materialList: {},
            selectedProduct: '',
            selectedPart: '',
            newPaperType: '',
            payment_terms: [],
        }
    }

    componentDidMount() {
        this.props.getPaymentTerms({});
        this.props.setActivePage('payment_terms');
    }

    componentDidUpdate(previousProps, previousState) {
        if (this.props.product.payment_terms !== previousProps.product.payment_terms) {
            console.log(this.props.product.payment_terms)
            this.setState({ payment_terms: this.props.product.payment_terms, openModal: false });
        }
    }


    handleDeleteItem(term, index) {

        var isConfirmed = window.confirm(`Delete (${term})?`);
        if (isConfirmed === false) {
            return;
        }
        if (term.length > 0) {
            this.props.removePaymentTerms({ term });
        }
    }


    handleTermsInput(evt, { value }) {
        this.setState({ term: value });
    }

    handleAddItem(product, part) {
        this.setState({ term: '', openModal: true });
    }

    handleConfirmAdd() {
        const { term } = this.state;
        console.log(term)
        if (term.length > 0) {

            this.props.addPaymentTerms({ term });
            this.setState({ openModal: false });
        }
    }

    render() {
        const { openModal, payment_terms } = this.state;
        console.log(this.props)

        return (
            <Container>
                <Modal open={openModal}>
                    <Modal.Header>Add Terms </Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Grid columns={1}>
                                <Grid.Column>
                                    <Input
                                        fluid
                                        placeholder='Enter Term'
                                        onChange={this.handleTermsInput.bind(this)}
                                    />
                                </Grid.Column>
                            </Grid>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ openModal: false })}>
                            Cancel
                        </Button>
                        <Button primary onClick={this.handleConfirmAdd.bind(this)}>
                            Confirm
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Header as="h2">Payment Terms</Header>
                <Segment raised padded='very' key={payment_terms._id}>
                    <Header as="h3" textAlign="center">Terms<Button floated='right' onClick={this.handleAddItem.bind(this, payment_terms._id)}>ADD</Button></Header>
                    <List ordered divided selection>
                        {(payment_terms.values.length > 0) &&
                            payment_terms.values.map((terms, index) => {
                                return (

                                    <List.Item key={terms}>
                                        <List.Content floated='right' verticalAlign='middle'>
                                            <Icon link name='delete' className='cross-hover' onClick={this.handleDeleteItem.bind(this, terms, index)} />
                                        </List.Content>
                                        <List.Header>{terms}</List.Header>
                                    </List.Item>
                                )
                            })
                        }
                    </List>
                </Segment>
            </Container>

        )
    }
}

const mapStateToProps = ({ product }) => {
    return { product };
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setActivePage: setActivePage,
        getPaymentTerms: getPaymentTerms,
        addPaymentTerms: addPaymentTerms,
        removePaymentTerms: removePaymentTerms
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(PaymentTerms);